import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Card, Button } from "react-bootstrap";
import axios from "axios";

const ViewCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState(null);

  const fetchCategory = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("https://ecom-api.applligentdemo.com/category/getCategory", {
        headers: {
          Authorization: token,
        },
      });

      const all = response.data.categories;
      const selected = all.find((cat) => cat._id === id);

      if (selected) setCategory(selected);
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, [id]);

  if (!category) return <p>Loading...</p>;

  return (
    <Container className="mt-5" >
      <Button variant="secondary" onClick={() => navigate("/category")}>
        ← Back
      </Button>
      <Card className="mt-3 p-4">
        <h3>{category.name}</h3>
        <img
          src={category.image}
          alt="Category"
          width={100}
          height={100}
          style={{ objectFit: "cover", borderRadius: "8px", margin: "10px 0" }}
        />
        <p><strong>Description:</strong> {category.description}</p>
        <p><strong>Status:</strong> {category.status ? "Active" : "Inactive"}</p>
        <p><strong>Created At:</strong> {new Date(category.createdAt).toLocaleString()}</p>
      </Card>
    </Container>
  );
};

export default ViewCategory;
